import { BuildingConfig } from './types';

export const MODELS: BuildingConfig[] = [
  {
    name: 'watertower',
    withFloors: true,
    path: '/models/building/watertower.glb',
    buildingIds: ['4504235283172098'],
    coords: [37.536738, 55.74673],
    scale: 1,
    rotateX: 0,
    rotateY: 0,
    rotateZ: 0,
    moveX: 400,
    moveY: 400,
    moveZ: 0,
  },
];
